import { normalize, denormalize, schema } from 'normalizr'
import omit from 'lodash/omit'

const col = new schema.Entity('cols', {}, { processStrategy })
col.define({
  children: [col]
})

const row = new schema.Entity('rows', {}, { processStrategy })
row.define({
  children: [row]
})

const report = new schema.Entity('reports', {
  cols: col,
  rows: row
})

function normalizeReport (reportObj) {
  const normalized = normalize(reportObj, report)
  const r = normalized.entities.reports[normalized.result]
  r.allCols = normalized.entities.cols
  r.allRows = normalized.entities.rows
  return r
}

function denormalizeReport (reportObj) {
  const entities = {
    reports: {
      [reportObj.id]: reportObj
    },
    cols: reportObj.allCols,
    rows: reportObj.allRows
  }
  const r = { ...reportObj }
  delete r.allCols
  delete r.allRows
  const denormalized = denormalize(r, report, entities)
  denormalized.cols = denormalized && denormalized.cols ? denormalized.cols.children : null
  denormalized.rows = denormalized && denormalized.rows ? denormalized.rows.children : null
  return denormalized
}

function processStrategy (entity, parent) {
  entity = omit(entity, ['childrenIds'])
  if (entity.children && entity.children.length > 0) {
    entity.children.sort((a, b) => a.order - b.order).forEach((v, i) => {
      v.order = i + 1
    })
  }
  entity.parent = parent.id
  return entity
}

export {
  normalizeReport,
  denormalizeReport
}



// WEBPACK FOOTER //
// ./src/components/report-tables/model.js